var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupBackgroundStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_188851",
    "data-name": "Group 188851",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 556.829,
    height: 493.692,
    viewBox: "0 0 556.829 493.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4351",
    "data-name": "Rectangle 4351",
    width: 556.829,
    height: 493.692,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_188850",
    "data-name": "Group 188850",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42028",
    "data-name": "Path 42028",
    d: "M12.566,357.178a8.63,8.63,0,0,0,4.946-3.122,11.5,11.5,0,0,0,2.283-5.443,10.08,10.08,0,0,0,8.81,7.816A20.683,20.683,0,0,0,23.09,360.7c-1.389,1.481-2.652,3.312-2.566,5.341a20.149,20.149,0,0,0-2.6-5.384,9.242,9.242,0,0,0-5.357-3.475",
    transform: "translate(3.296 91.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42029",
    "data-name": "Path 42029",
    d: "M316.624,44.865a8.629,8.629,0,0,0,4.947-3.123,11.49,11.49,0,0,0,2.283-5.442,10.076,10.076,0,0,0,8.81,7.816,20.71,20.71,0,0,0-5.516,4.267c-1.387,1.481-2.651,3.312-2.565,5.341a20.145,20.145,0,0,0-2.6-5.384,9.245,9.245,0,0,0-5.358-3.475",
    transform: "translate(83.048 9.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42030",
    "data-name": "Path 42030",
    d: "M429.445,376.5a89.262,89.262,0,0,1,4.532-8.586q1.1,4.215,2.191,8.43l11.121,1.977q-4.58,3.567-9.283,6.973-.042,5.959.486,11.9-3.058-4.164-6.216-8.253l-9.689,6.943q1.89-5.415,3.781-10.83l-8.736-6.1c3.552-.847,7.105-1.7,11.814-2.456",
    transform: "translate(109.542 96.5)",
    fill: "#f2b212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42031",
    "data-name": "Path 42031",
    d: "M429.311,98.451q1.956-3.541,4.241-6.882.574,3.45,1.145,6.9a1.417,1.417,0,0,0,1.1,1.351l5.953,2.631a59.894,59.894,0,0,1-6.6,3.182q.085,3.982.169,7.963-2.223-3.342-4.447-6.683-3.249,2.7-6.7,5.136,1.551-4.022,3.1-8.045a.864.864,0,0,0-.194-1.1L422.313,97.1c2.175.441,4.351.88,7,1.352",
    transform: "translate(110.77 24.018)",
    fill: "#ff9681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42032",
    "data-name": "Path 42032",
    d: "M5.092,280.755q1.628-2.142,3.416-4.161,0,2.46.173,4.914,2.568,1.329,5.088,2.744a51.719,51.719,0,0,1-5.226.973q.22,2.806.625,5.592-1.719-1.979-3.438-3.956a.3.3,0,0,0-.178-.125.314.314,0,0,0-.191.068L.77,289.736q1.335-2.681,2.672-5.362-1.8-2.246-3.441-4.622c1.583.274,3.147.669,5.091,1",
    transform: "translate(0 72.549)",
    fill: "#f2b212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42033",
    "data-name": "Path 42033",
    d: "M26.812,49.5l4.437-3.44-.284,5.475a1.644,1.644,0,0,0,.56,1.543L35.488,57.5a46.243,46.243,0,0,1-5.071-.162q-.028,3.245-.058,6.492Q28.4,61.064,26.449,58.3a.685.685,0,0,0-.78-.355l-6.939.4L23.037,54.1a.814.814,0,0,0,.258-1.1q-1.286-3.421-2.573-6.843A36.612,36.612,0,0,1,26.812,49.5",
    transform: "translate(4.913 12.081)",
    fill: "#f2b212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42034",
    "data-name": "Path 42034",
    d: "M64.028,11.32q.1-5.663.384-11.32,3.463,3.906,7.026,7.723a83.731,83.731,0,0,1,9.023-3.672q-2.143,4.794-4.285,9.588a1.74,1.74,0,0,0-.191.631,1.718,1.718,0,0,0,.111.582,110.558,110.558,0,0,0,4.25,11.311,92.5,92.5,0,0,0-7.81-5.249,87.469,87.469,0,0,0-4.874,10.16L65.746,19.595a.759.759,0,0,0-.732-.769L53.724,16c3.3-1.6,6.606-3.192,10.3-4.678",
    transform: "translate(14.091)",
    fill: "#ef5255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupBackgroundStars);
export default __webpack_public_path__ + "static/media/signup-background-stars.b7982ee7c9caba0ab37596a74908d58c.svg";
export { ForwardRef as ReactComponent };